// Vendor imports
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { CheckExperiment } = require('client-v2/common/containers/rollouts')

const bem = BemEntity('BottomCallToActionSection')

function BottomCallToActionSection(props) {
  const onButtonClick = props.isSULandingPage
    ? props.onSULoginClick
    : props.onSignupClick
  return tag('div', {
    className: bem.block()
  },
    tag('div', {
      className: bem.element('content')
    },
      tag('div', {
        className: bem.element('heading')
      },
        `Curate the`,
        tag('br'),
        `best of the internet`
      ),

      tag(CheckExperiment, {
        experimentKey: '*logged_out_top_cta',
        renderWithModifier: modifier => {
          if (modifier === 'b' || modifier === 'c') {
            return tag('div', {
              className: bem.element('subheading')
            },
              `Create collections of interesting things`,
              tag('br'),
              `to share them with your friends.`
            )
          }
          return tag('div', {
            className: bem.element('subheading')
          },
            `You can save anything from anywhere.`,
            tag('br'),
            `Mix learns what you love to show you even more.`
          )
        }
      }),

      tag('div', {
        className: bem.element('buttons-container')
      },
        tag('button', {
          className: bem.element('button', 'primary'),
          onClick: onButtonClick
        },
          `Join Mix`
        )
      )
    ),
    tag('div', {
      className: bem.element('image')
    })
  )
}

BottomCallToActionSection.propTypes = {
  // Flags
  isSULandingPage: PropTypes.bool.isRequired,
  // Callbacks
  onSignupClick: PropTypes.func.isRequired,
  onSULoginClick: PropTypes.func.isRequired
}

module.exports = BottomCallToActionSection
